import axios from "axios";

export default class SpeedNetworkingService {
  async joinSpeedNetworking(roomId): Promise<any> {
    return await axios.post(`api/rooms/${roomId}/join_speed_networking`, {});
  }
  async leaveSpeedNetworking(roomId): Promise<any> {
    return await axios.post(`api/rooms/${roomId}/leave_speed_networking`, {});
  }
  async changeCycle(roomId, data): Promise<any> {
    return await axios.post(
      `api/rooms/${roomId}/change_cycle_speed_networking`,
      data
    );
  }
}
